import importCotas from './import-cotas';
export * from './import-cotas';

export default { importCotas };
